import React, { useState, useEffect } from "react";
import {
  Dropdown,
  Button,
  Form,
  Card,
  Checkbox,
  Icon,
  Modal,
} from "semantic-ui-react";
import { Store } from "../Utility/Store";
import {
  fetchPOCAggs,
  fetchPOCData,
  set_query,
  set_program,
  set_center_hub,
  set_institutions,
  set_technology,
  set_disease,
  set_licensing,
  set_status,
  set_filters_display,
  set_per_page,
  set_start_page,
} from "../Utility/actions";
import { Popover } from "react-tiny-popover";
import { CopyToClipboard } from "react-copy-to-clipboard";

export default function FiltersContainer() {
  const { state, dispatch } = React.useContext(Store);
  const [centerHub, setCenterHub] = useState([]);
  const [institution, setInstitution] = useState([]);
  const [disease, setDisease] = useState([]);
  const [technology, setTechnology] = useState([]);
  const [program, setProgram] = useState([]);
  const [licensing, setLicensing] = useState([]);
  const [status, setStatus] = useState([]);
  const [searchQuery, setSearchQuery] = useState("");
  const [isPopoverOpen, setIsPopoverOpen] = useState(false);

  const [showCenterHub, setshowCenterHub] = useState(true);
  const [showProgram, setshowProgram] = useState(false);
  const [showDisease, setshowDisease] = useState(true);
  const [showTechnology, setshowTechnology] = useState(true);
  const [showStatus, setshowStatus] = useState(false);
  const [showInstitution, setshowInstitution] = useState(true);
  const [showLicensing, setshowLicensing] = useState(true);
  const [showSearch, setShowSearch] = useState(false);
  const [queryFilters, setQueryFilters] = useState({});
  const [paramLoaded, setParamLoaded] = useState(false);
  const [perPage, setPerPage] = useState(20);

  const perPage_options = [
    {
      key: "10",
      text: "10",
      value: 10,
    },
    {
      key: "25",
      text: "25",
      value: 25,
    },
    {
      key: "50",
      text: "50",
      value: 50,
    },
    {
      key: "100",
      text: "100",
      value: 100,
    },
  ];

  useEffect(() => {
    if (state.aggs && state.aggs.length === 0) {
      fetchPOCAggs(dispatch, {});
    }
  }, []);

  useEffect(() => {
    if (state.results.length === 0) {
      var url_string = window.location.href;
      var url = new URL(url_string);
      let obj = {
        query: url.searchParams.get("query"),
        program: url.searchParams.get("program"),
        center_hub: url.searchParams.get("center_hub"),
        institutions: url.searchParams.get("institutions"),
        technology: url.searchParams.get("technology"),
        disease: url.searchParams.get("disease"),
        licensing: url.searchParams.get("licensing"),
        status: url.searchParams.get("status"),
      };
      setParamLoaded(true);
      setQueryFilters(obj);
      fetchPOCData(dispatch, obj);
      if (obj.query) {
        set_query(dispatch, decodeURIComponent(obj.query));
      }
      if (obj.program) {
        set_program(dispatch, decodeURIComponent(obj.program));
      }
      if (obj.center_hub) {
        set_center_hub(dispatch, decodeURIComponent(obj.center_hub));
      }
      if (obj.institutions) {
        set_institutions(dispatch, decodeURIComponent(obj.institutions));
      }
      if (obj.technology) {
        set_technology(dispatch, decodeURIComponent(obj.technology));
      }
      if (obj.disease) {
        set_disease(dispatch, decodeURIComponent(obj.disease));
      }
      if (obj.licensing) {
        set_licensing(dispatch, decodeURIComponent(obj.licensing));
      }
      if (obj.status) {
        set_status(dispatch, decodeURIComponent(obj.status));
      }
    }
  }, []);

  useEffect(() => {
    if (state.aggs && state.aggs.center_hub) {
      let options = [];
      state.aggs.center_hub.buckets.map((item, index) => {
        let obj = {
          key: index + "_center_hub",
          text: item.key,
          value: item.key,
        };
        options.push(obj);
      });
      setCenterHub(options);
    }

    if (state.aggs && state.aggs.institution) {
      let options = [];
      state.aggs.institution.buckets.map((item, index) => {
        let obj = {
          key: index + "_institution",
          text: item.key,
          value: item.key,
        };
        options.push(obj);
      });
      setInstitution(options);
    }
    if (state.aggs && state.aggs.disease) {
      let options = [];
      state.aggs.disease.buckets.map((item, index) => {
        let obj = {
          key: index + "_disease",
          text: item.key,
          value: item.key,
        };
        options.push(obj);
      });
      setDisease(options);
    }
    if (state.aggs && state.aggs.technology) {
      let options = [];
      state.aggs.technology.buckets.map((item, index) => {
        let obj = {
          key: index + "_technology",
          text: item.key,
          value: item.key,
        };
        options.push(obj);
      });
      setTechnology(options);
    }
    if (state.aggs && state.aggs.program) {
      let options = [];
      state.aggs.program.buckets.map((item, index) => {
        let obj = {
          key: index + "_program",
          text: item.key,
          value: item.key,
        };
        options.push(obj);
      });
      setProgram(options);
    }
    if (state.aggs && state.aggs.licensing) {
      let options = [];
      state.aggs.licensing.buckets.map((item, index) => {
        let obj = {
          key: index + "_licensing",
          text: item.key,
          value: item.key,
        };
        options.push(obj);
      });
      setLicensing(options);
    }
    if (state.aggs && state.aggs.status) {
      let options = [];
      state.aggs.status.buckets.map((item, index) => {
        let obj = {
          key: index + "_status",
          text: item.key,
          value: item.key,
        };
        options.push(obj);
      });
      setStatus(options);
    }
  }, [state.aggs]);

  let fetchResult = (change, value) => {
    let obj = {
      query: state.query,
      program: state.program,
      center_hub: state.center,
      institutions: state.institutions,
      technology: state.technology,
      disease: state.disease,
      licensing: state.licensing,
      status: state.status,
      sort_type: "asc",
      sort_field: "",
      size: state.per_page,
    };
    switch (change) {
      case "query":
        obj.query = value;
        break;
      case "changeHub":
        obj.center_hub = value;
        break;
      case "institution":
        obj.institutions = value;
        break;
      case "disease":
        obj.disease = value;
        break;
      case "technology":
        obj.technology = value;
        break;
      case "program":
        obj.program = value;
        break;
      case "licensing":
        obj.licensing = value;
        break;
      case "status":
        obj.status = value;
        break;
      case "per_page":
        obj.size = value;
      default:
        break;
    }
    fetchPOCData(dispatch, obj);
  };

  let changeFilter = (e, { name, value }) => {
    fetchResult(name, value);
    set_start_page(dispatch, 1);
    switch (name) {
      case "query":
        set_query(dispatch, value);
        break;
      case "changeHub":
        set_center_hub(dispatch, value);
        break;
      case "institution":
        set_institutions(dispatch, value);
        break;
      case "disease":
        set_disease(dispatch, value);
        break;
      case "technology":
        set_technology(dispatch, value);
        break;
      case "program":
        set_program(dispatch, value);
        break;
      case "licensing":
        set_licensing(dispatch, value);
        break;
      case "status":
        set_status(dispatch, value);
        break;
      case "per_page":
        set_per_page(dispatch, value);
        break;
      default:
        break;
    }
  };

  let onchange_search = (e) => {
    setSearchQuery(e.target.value);
  };

  let search_query = () => {
    set_query(dispatch, searchQuery);
    fetchResult("query", searchQuery);
  };

  let setFilterDisplay = (e, data) => {
    let filter_display = {
      program: state.filter_display.program,
      changeHub: state.filter_display.changeHub,
      disease: state.filter_display.disease,
      technology: state.filter_display.technology,
      status: state.filter_display.status,
      institution: state.filter_display.institution,
      licensing: state.filter_display.licensing,
      search: state.filter_display.search,
    };
    switch (data.name) {
      case "program":
        filter_display.program = data.checked;
        setshowProgram(data.checked);
        break;
      case "changeHub":
        filter_display.changeHub = data.checked;
        setshowCenterHub(data.checked);
        break;
      case "disease":
        filter_display.disease = data.checked;
        setshowDisease(data.checked);
        break;
      case "technology":
        filter_display.technology = data.checked;
        setshowTechnology(data.checked);
        break;
      case "status":
        filter_display.status = data.checked;
        setshowStatus(data.checked);
        break;
      case "institution":
        filter_display.institution = data.checked;
        setshowInstitution(data.checked);
        break;
      case "licensing":
        filter_display.licensing = data.checked;
        setshowLicensing(data.checked);
      case "search":
        filter_display.search = data.checked;
        setShowSearch(data.checked);
        break;
    }
    set_filters_display(dispatch, filter_display);
  };

  let copySuccess = () => {
    var x = document.getElementById("snackbar");

    // Add the "show" class to DIV
    x.className = "show";

    // After 3 seconds, remove the show class from DIV
    setTimeout(function () {
      x.className = x.className.replace("show", "");
    }, 3000);
  };

  return (
    <div>
      <div id="snackbar">Link Copied</div>
      <div className="poc_funding_search_filter_container">
        <div className="filter_container_header">
          <h3>Search Query</h3>
          <div className="poc_filter_share">
            <CopyToClipboard
              text={`${window.location.href}?query=${encodeURIComponent(
                state.query
              )}&program=${encodeURIComponent(
                state.program
              )}&center_hub=${encodeURIComponent(
                state.center
              )}&institutions=${encodeURIComponent(
                state.institutions
              )}&technology=${encodeURIComponent(
                state.technology
              )}&disease=${encodeURIComponent(
                state.disease
              )}&licensing=${encodeURIComponent(
                state.licensing
              )}&status=${encodeURIComponent(state.status)}`}
              onCopy={copySuccess}
            >
              <a style={{ cursor: "pointer" }}>
                {" "}
                <span>
                  {" "}
                  <Icon name="share square"></Icon>Share Link
                </span>
              </a>
            </CopyToClipboard>
          </div>
        </div>
        <div className="filters_conatiner">
          <div className="filter_option_container">
            {showProgram && paramLoaded ? (
              <div className="filter_option">
                <span className="filter_name">Program</span>
                <Dropdown
                  placeholder="Program"
                  search
                  selection
                  clearable
                  options={program}
                  onChange={changeFilter}
                  selectOnBlur={false}
                  name="program"
                  defaultValue={decodeURIComponent(queryFilters.program)}
                />
              </div>
            ) : (
              ""
            )}
            {showCenterHub && paramLoaded ? (
              <div className="filter_option">
                <span className="filter_name">Center / Hub</span>
                <Dropdown
                  placeholder="Center Hub"
                  search
                  selection
                  clearable
                  options={centerHub}
                  onChange={changeFilter}
                  name="changeHub"
                  selectOnBlur={false}
                  defaultValue={decodeURIComponent(queryFilters.center_hub)}
                  style={{
                    maxWidth: "200px",
                  }}
                />
              </div>
            ) : (
              ""
            )}

            {showInstitution && paramLoaded ? (
              <div className="filter_option">
                <span className="filter_name">University / Institution</span>
                <Dropdown
                  placeholder="Institution"
                  search
                  selection
                  clearable
                  options={institution}
                  onChange={changeFilter}
                  name="institution"
                  selectOnBlur={false}
                  defaultValue={decodeURIComponent(queryFilters.institutions)}
                  style={{
                    maxWidth: "200px",
                  }}
                />
              </div>
            ) : (
              ""
            )}

            {showTechnology && paramLoaded ? (
              <div className="filter_option">
                <span className="filter_name">Technology Type</span>
                <Dropdown
                  placeholder="Technology"
                  search
                  selection
                  clearable
                  options={technology}
                  onChange={changeFilter}
                  name="technology"
                  selectOnBlur={false}
                  defaultValue={decodeURIComponent(queryFilters.technology)}
                  style={{
                    maxWidth: "200px",
                  }}
                />
              </div>
            ) : (
              ""
            )}

            {showDisease && paramLoaded ? (
              <div className="filter_option">
                <span className="filter_name">Disease Area</span>
                <Dropdown
                  placeholder="Disease"
                  search
                  selection
                  clearable
                  options={disease}
                  onChange={changeFilter}
                  name="disease"
                  selectOnBlur={false}
                  defaultValue={decodeURIComponent(queryFilters.disease)}
                  style={{
                    maxWidth: "200px",
                  }}
                />
              </div>
            ) : (
              ""
            )}

            {showLicensing && paramLoaded ? (
              <div className="filter_option">
                <span className="filter_name">Licensing Status</span>
                <Dropdown
                  placeholder="Licensing"
                  search
                  selection
                  clearable
                  options={licensing}
                  onChange={changeFilter}
                  name="licensing"
                  selectOnBlur={false}
                  defaultValue={decodeURIComponent(queryFilters.licensing)}
                  style={{
                    maxWidth: "200px",
                  }}
                />
              </div>
            ) : (
              ""
            )}
            {showStatus && paramLoaded ? (
              <div className="filter_option">
                <span className="filter_name">Project Completion Status</span>
                <Dropdown
                  placeholder="Status"
                  search
                  selection
                  clearable
                  options={status}
                  onChange={changeFilter}
                  name="status"
                  selectOnBlur={false}
                  defaultValue={decodeURIComponent(queryFilters.status)}
                  style={{
                    maxWidth: "200px",
                  }}
                />
              </div>
            ) : (
              ""
            )}

<div className="popover_container">
            <Popover
              align={"end"}
              isOpen={isPopoverOpen}
              position={["right"]} // if you'd like, you can limit the positions
              padding={6} // adjust padding here!
              reposition={true} // prevents automatic readjustment of content position that keeps your popover content within its parent's bounds
              onClickOutside={() => setIsPopoverOpen(false)} // handle click events outside of the popover/target here!
              content={(
                { position, nudgedLeft, nudgedTop } // you can also provide a render function that injects some useful stuff!
              ) => (
                <div
                  style={{
                    padding: "20px",
                    marginTop: "110px",
                    marginRight: "-60px",
                  }}
                >
                  <Card>
                    <Card.Content>
                      <Form>
                        <Form.Field>
                          <Checkbox
                            label="Program"
                            name="program"
                            onChange={setFilterDisplay}
                            checked={showProgram}
                          />
                        </Form.Field>
                        <Form.Field>
                          <Checkbox
                            label="Center/Hub"
                            name="changeHub"
                            onChange={setFilterDisplay}
                            checked={showCenterHub}
                          />
                        </Form.Field>
                        <Form.Field>
                          <Checkbox
                            label="Disease Area"
                            name="disease"
                            onChange={setFilterDisplay}
                            checked={showDisease}
                          />
                        </Form.Field>
                        <Form.Field>
                          <Checkbox
                            label="Technology Type"
                            name="technology"
                            onChange={setFilterDisplay}
                            checked={showTechnology}
                          />
                        </Form.Field>
                        <Form.Field>
                          <Checkbox
                            label="Project Completion Status"
                            name="status"
                            onChange={setFilterDisplay}
                            checked={showStatus}
                          />
                        </Form.Field>
                        <Form.Field>
                          <Checkbox
                            label="University of Institution"
                            name="institution"
                            onChange={setFilterDisplay}
                            checked={showInstitution}
                          />
                        </Form.Field>
                        <Form.Field>
                          <Checkbox
                            label="Licensing"
                            name="licensing"
                            onChange={setFilterDisplay}
                            checked={showLicensing}
                          />
                        </Form.Field>
                      </Form>
                    </Card.Content>
                  </Card>
                </div>
              )}
            >
              <div
                style={{
                  cursor: "pointer",
                  color: "#1D7DAA",
                  marginTop: "25px",
                }}
                onClick={() => setIsPopoverOpen(!isPopoverOpen)}
              >
                <Icon name="plus circle" size="big" />
              </div>
            </Popover>
          </div>

            <Form>
              <Form.Group>
                <Form.Field>
                  <label>Search Keywords</label>
                  <input placeholder="Keywords" onChange={onchange_search} />
                </Form.Field>
                <Form.Field>
                  <Button
                    type="submit"
                    onClick={search_query}
                    className="poc_search_button"
                  >
                     <Icon name='search' />Search
                  </Button>
                </Form.Field>
              </Form.Group>
            </Form>
          </div>

        </div>

        {/* <div className="per_page_display ui form">
        <div>Display Per Page </div>
        <Dropdown
          placeholder="10"
          selection
          options={perPage_options}
          onChange={changeFilter}
          selectOnBlur={false}
          name="per_page"
          style={{
            minWidth: '20px',
            marginTop : '4px'
          }}
        />
        </div> */}
      </div>
    </div>
  );
}
